import {useState} from "react"
import {fetchData, postData} from "../util/Server"
import Endpoints from "../util/Endpoints"
import {ERROR, Notify, SUCCESS} from "../util/Notify"

const useRefundDetail = (id) => {
    const [refund, setRefund] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [isCancelling, setIsCancelling] = useState(false)

    const loadRefund = () => {
        if (!id) return
        setIsLoading(true)

        fetchData(Endpoints.ADMIN_REFUND_DETAIL(id))
            .then(res => res.json())
            .then(res => {
                setIsLoading(false)
                if (res?.code === 200) {
                    setRefund(res.data || null)
                } else {
                    Notify(res?.message || "Failed to load refund", ERROR)
                }
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    const cancelRefund = (onSuccess) => {
        if (!id) return
        setIsCancelling(true)

        const fd = new FormData()

        postData(Endpoints.ADMIN_REFUND_CANCEL(id), fd)
            .then(res => res.json())
            .then(res => {
                setIsCancelling(false)
                if (res?.code === 200) {
                    Notify(res?.message || "Refund cancelled", SUCCESS)
                    if (onSuccess) onSuccess()
                    loadRefund()
                } else {
                    Notify(res?.message || "Failed to cancel refund", ERROR)
                }
            })
            .catch(() => {
                setIsCancelling(false)
            })
    }

    return {refund, isLoading, isCancelling, loadRefund, cancelRefund}
}

export default useRefundDetail
